module.exports = __webpack_public_path__ + "img/title_main_pc.5de43983.svg";